import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-cream">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-emerald-100/60 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-amber-100/50 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="w-full">
            <span className="inline-flex items-center gap-2 rounded-full bg-emerald-100 px-4 py-1.5 text-xs font-semibold text-emerald-800">
              <i className="ri-sparkling-line w-4 h-4 flex items-center justify-center" />
              {t('home.heroBadge')}
            </span>
            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold text-stone-900 leading-tight">
              {t('home.heroTitle')}
            </h1>
            <p className="mt-5 text-base md:text-lg text-stone-600 leading-relaxed">{t('home.heroSubtitle')}</p>
            <p className="mt-3 text-sm md:text-base text-stone-500 leading-relaxed">{t('home.heroSubtitle2')}</p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="rounded-md bg-emerald-600 px-6 py-3 text-sm font-semibold text-white hover:bg-emerald-700 text-center whitespace-nowrap cursor-pointer"
              >
                {t('home.ctaSpreadsheet')}
              </a>
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="rounded-md bg-amber-500 px-6 py-3 text-sm font-semibold text-white hover:bg-amber-600 text-center whitespace-nowrap cursor-pointer"
              >
                {t('home.ctaBuyNow')}
              </a>
            </div>

            <div className="mt-5">
              <Link
                to="/usfans-spreadsheet-beginner-guide"
                className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:text-emerald-800 cursor-pointer whitespace-nowrap"
              >
                {t('home.ctaGuide')}
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </Link>
            </div>

            <p className="mt-8 text-xs text-stone-500">{t('home.heroTrust')}</p>
          </div>

          <div className="w-full">
            <div className="relative rounded-lg overflow-hidden bg-white border border-stone-200">
              <img
                src="https://readdy.ai/api/search-image?query=Creative%20overhead%20flat%20lay%20of%20fashion%20shopping%20essentials%20including%20clean%20white%20sneakers%2C%20folded%20denim%20jacket%2C%20leather%20wallet%2C%20sunglasses%20and%20a%20smartphone%20on%20a%20warm%20cream%20linen%20surface%2C%20fresh%20airy%20editorial%20style%2C%20soft%20natural%20lighting%20with%20gentle%20shadows%2C%20European%20catalog%20aesthetic&width=800&height=800&seq=hero-collage-01&orientation=squarish"
                alt="USFans Spreadsheet product collage"
                title="USFans Spreadsheet products"
                className="w-full h-64 md:h-[420px] object-cover object-top"
              />
              <div className="absolute top-4 left-4 rounded-md bg-white/90 px-3 py-2 text-xs font-semibold text-stone-800">
                <span className="flex items-center gap-1.5">
                  <i className="ri-links-line text-emerald-600 w-4 h-4 flex items-center justify-center" />
                  {t('home.navSpreadsheet')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}